// Import general mixin for shared functionality.
import mixin from './mixin';

import SourceSet from './components/SourceSet.vue';

// Import axios for API consuming in a clean interface.
const axios = require('axios');

const ShopCartApp = {
    mixins: [mixin],
    components: { SourceSet },
    data() {
        return {
            dataApi: '',
            dataVatlabel: 'incl. btw',
            dataCountries: [],
            dataUrl: '',

            cart: [],
            newProduct: null,
            selectedCountry: '',
            city: '',
            postalcode: '',
            shipping: 0,
            formValidated: false,
        }
    },
    computed: {
        subtotal() {
            return this.cart.map(product => product.price * product.amount).reduce((acc, price) => acc + price, 0);
        },
        total() {
            return this.postalcodeFree ? this.subtotal : this.subtotal + this.shipping;
        },
        formValid() {
            return this.city && (this.strip(this.postalcode).length === 4 || this.strip(this.postalcode).length === 6);
        },
        queryParams() {
            const urlParams = new URLSearchParams();
            urlParams.set('postcode', this.postalcode);
            return urlParams.toString();
        },
    },
    methods: {
        async init() {
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.vatlabel) this.dataVatlabel = this.$el.dataset.vatlabel;
            if (this.$el.dataset.url) this.dataUrl = this.$el.dataset.url;

            if (this.$el.dataset.countries) {
                this.dataCountries = JSON.parse(this.$el.dataset.countries);
                if (!this.selectedCountry) this.selectedCountry = this.dataCountries[0];
            } 

            if (localStorage.getItem('cart')) this.cart = JSON.parse(localStorage.getItem('cart'));
            if (localStorage.getItem('new')) this.newProduct = this.cart.find(product => product.id === localStorage.getItem('new'));
        },
        async getPostalcode() {
            try {
                const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        updateCart() {
            localStorage.setItem('cart', JSON.stringify(this.cart));
        },
        plusOne(id) {
            let product = this.cart.find(product => product.id === id);
            product.amount++;
            this.newProduct = { ...product };
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "EUR",
                    value: this.priceExBtw(product.price),
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.name,
                            price: this.priceExBtw(product.price),
                            quantity: 1
                        }
                    ]
                }
            });

            this.updateCart();
        },
        minusOne(id) {
            let product = this.cart.find(product => product.id === id);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    currency: "EUR",
                    value: this.priceExBtw(product.price),
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.name,
                            price: this.priceExBtw(product.price),
                            quantity: 1
                        }
                    ]
                }
            });

            if (product.amount === 1) {
                this.removeFromCart(id);
            }
            else {
                product.amount--;
                this.updateCart();
            }
        },
        removeFromCart(id) {
            this.cart = this.cart.filter(product => product.id != id);      
            this.updateCart();

        },
        openDropdown(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.add('is-active');

                document.addEventListener('click', (event) => {
                    if (!this.$refs[ref].contains(event.target)) {
                        this.$refs[ref].classList.remove('is-active');
                    }
                });
            }
        },
        setCountry(country, ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.remove('is-active');
            }
            this.selectedCountry = country;
            const url = new URL(location);
            url.searchParams.set('country', this.selectedCountry);
            if (this.selectedCountry === this.dataCountries[0]) url.searchParams.delete('country');
            history.pushState({}, '', url);
        },
        async checkPostalcode() {
            const response = await this.getPostalcode();
            if (response) this.shipping = response.data;
            if (this.formValid) this.formValidated = true;
        },      
        navigate() {
            if (this.formValid && this.dataUrl) {
                localStorage.setItem('address', JSON.stringify({
                    country: this.selectedCountry,
                    city: this.city.trim(),
                    postalcode: this.strip(this.postalcode),
                }));
                localStorage.setItem('cost', JSON.stringify({
                    subtotal: this.subtotal,
                    total: this.total,
                    shipping: this.shipping,
                }));
                //begin checkout, value = subtotal zonder shippingcost en btw

                var dataLayerItems = [];

                this.cart.forEach((item) =>
                    dataLayerItems.push({
                        "item_id": item.id,
                        "item_name": item.name,
                        "price": this.priceExBtw(item.price),
                        "quantity": item.amount
                    })
                );

                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "begin_checkout",
                    ecommerce: {
                        currency: "EUR",
                        value: this.priceExBtw(this.subtotal),
                        items: dataLayerItems
                    }
                });
                window.location = this.dataUrl;
            }
        },
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('country')) this.selectedCountry = urlParams.get('country');

        let costObject = JSON.parse(localStorage.getItem('cost'));
        if (costObject && costObject.shipping) this.shipping = parseFloat(costObject.shipping);

        let addressObject = JSON.parse(localStorage.getItem('address'));
        if (addressObject && addressObject.city) this.city = addressObject.city;
        if (addressObject && addressObject.postalcode) this.postalcode = addressObject.postalcode;
    },
    mounted() {
        this.init();
    },
};

export default ShopCartApp;
